import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  ProductTypeQueryInput,
  ProductTypeQueryResult,
} from "../../generated/gql/graphql";

const GET_PRODUCT_TYPES = gql`
  query ProductTypes($query: ProductTypeQueryInput) {
    productTypes(query: $query) {
      items {
        name
        id
      }
      totalCount
      page
      offset
      limit
    }
  }
`;

export default function useProductTypes(
  query?: ProductTypeQueryInput
): QueryResult<{ productTypes: ProductTypeQueryResult }> {
  return useQuery(GET_PRODUCT_TYPES, {
    variables: {
      query,
    },
    fetchPolicy: "cache-and-network",
  });
}
